<template>
  <!--
    Footerコンポーネント

    ブランド表示、基本機能へのアクセス（個人設定など）などを提供します。

    フッターに配置されるコンポーネントなので、このコンポーネント自体はfooterタグを使いません。
    footerタグを使うかどうかはこのフッターコンポーネントの利用側が決めます。
  -->
  <div class="footer" :class="containerClasses">
    <Divider></Divider>

    <div class="summaries footer-component">
      <gl-logo-app :onDarkBackground="dark" />
    </div>
  </div>
</template>

<script>
import Divider from '@/components/common/Divider.vue'

export default {
  components: { Divider },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerClasses() {
      return {
        dark: this.dark,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  font-size: var(--font-size-small);
  width: 100%;

  &.dark {
    background-color: var(--bg-color-accent);
    color: #fff;
  }

  .footer-component {
    padding: var(--spacing-medium-large);
    text-align: center;
  }

  .actions {
    display: flex;
    justify-content: center;
  }

  .action {
    margin-left: var(--spacing-small);

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
